export default function PHP_include() {
  return (
    <div>
      <h1>PHP_include</h1>
    </div>
  );
}
